module.exports = __webpack_public_path__ + "static/media/goldbelt.b3775485.webp";